import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import forms from "../../../../Data/Forms/Projects/Types/forms";
import headers from "../../../../Data/Forms/Projects/Types/headers";
import {
  create_project_type,
  get_project_type,
  update_project_type,
} from "../../../../Controllers/Projects/Types";
import Header from "../../../../Components/Header";
import Form from "../../../../Components/Form";
import Loadercomponent from "../../../../Components/Loader";
import { convert_to_file } from "../../../../Controllers/Global";

const ProjectTypesForm = () => {
  let { id } = useParams();

  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);

  const formdata = async (data) => {
    if (data?.status) {
      setButtonLoader(true);

      const type = id
        ? await update_project_type({ id: id, ...data?.data })
        : await create_project_type(data?.data);

      if (type?.status) {
        if (id) {
          navigate(-1);
        }
        toast?.success(type?.message);
        setButtonLoader(false);
      } else {
        toast?.error(type?.message);
        setButtonLoader(false);
      }
    }
  };

  const handleData = async (type) => {
    let image = type?.image ? type?.image : "";
    let file = await convert_to_file(image);
    let name = type?.name ? type?.name : "";
    let description = type?.name ? type?.description : "";
    let status = type?.status ? type?.status : 0;

    forms[0].options[0].form.value = [file];
    forms[0].options[1].form.value = name;
    forms[0].options[2].form.value = description;
    forms[0].options[3].form.value = status;

    setLoader(false);
    setValues([...values]);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      headers.navigate.path[1].name = "Edit";

      const data = {
        id: id,
      };

      const type = await get_project_type(data);

      if (type?.status) {
        handleData(type?.data);
      } else {
        toast?.error(type?.message);
      }
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [buttonLoader]);

  return (
    <Header header={headers}>
      <Loadercomponent loader={loader}>
        <Form
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
        />
      </Loadercomponent>
    </Header>
  );
};

export default ProjectTypesForm;
